module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_02_6DC79_1SD_HUN.dd7db01c.jpg";